<template>
  <star-rating
      read-only
      :increment="0.01"
      :fixed-points="2"
      :show-rating="false"
      :rating="rating"
      inactive-color="#000000"
      active-color="#ffc100"
      :star-size="15"
  ></star-rating>
</template>
<script>
import StarRating from 'vue-star-rating'

export default {
  name: "Rating",
  components: {
    StarRating
  },
  props: {
    rating: {
      type: Number,
      required: true,
      default: 4.2
    }
  },
}
{}
</script>

<style>
.vue-star-rating {
    display: inline-block !important;
}
</style>
